import axios from '../axios-marketplace';

const getList = (params) => axios.get('/configuracoes-vendas', {
  params,
});
const get = (id) => axios.get(`/configuracoes-vendas/${id}`, {});

const save = (catalogo) => {
  if (catalogo.id) {
    return axios.put(`/configuracoes-vendas/${catalogo.id}`, catalogo);
  }
  return axios.post('/configuracoes-vendas', catalogo);
};

const remover = (id) => axios.delete(`/configuracoes-vendas/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
